import React from 'react';
import { string } from 'prop-types';

import * as helpers from './helpers';

const ArrowRightIcon = ({ color, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props} height="10">
    <path
      fill={color}
      d="M1.22578 10C0.922238 10 0.618477 9.8868 0.381143 9.65907C-0.109432 9.18753 -0.128995 8.40309 0.337288 7.907L3.07995 4.99131L0.340083 2.09583C-0.12792 1.60148 -0.110722 0.817043 0.378564 0.343771C0.868064 -0.129502 1.64391 -0.111901 2.11192 0.382667L5.66009 4.13169C6.1124 4.60974 6.11326 5.36268 5.66289 5.84225L2.11493 9.61474C1.87351 9.8705 1.5504 10 1.22578 10Z"
    />
  </svg>
);

ArrowRightIcon.propTypes = {
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

ArrowRightIcon.defaultProps = {
  ...helpers.getDefaultIconDimensionsProps(12, 8),
};

export default ArrowRightIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/arrow-right.js